<script setup>
const props = defineProps([
	'doc',
	'project',
	'objects',
	'reports',
	'workTypeStatistics',
	'workTypes',
	'prescriptions',
	'checklists',
	't',
])

const objects = props.objects.map((object) => {
	object.reports = props.reports.filter((report) => report.object_id == object.id)

	object.prescriptions = props.prescriptions.filter(
		(prescription) => prescription.object_id == object.id
	)

	object.checklists = props.checklists.filter((checklist) => checklist.object_id == object.id)

	return object
})

let minorSpecialists = []
props.objects.forEach((object) => {
	const filteredSpecialists = object.employees.filter((item) => !item.main_specialist)

	minorSpecialists = minorSpecialists.concat(filteredSpecialists)
})

const mainSpecialists = []

objects.forEach((object) => {
	const mainSpec = object.employees.find((item) => item.main_specialist == true)

	if (mainSpec) {
		mainSpec.object = object
		mainSpecialists.push(mainSpec)
	}
})

const reportFilesByObject = {}

props.reports.forEach((report) => {
	if (Array.isArray(report?.files)) {
		if (!reportFilesByObject[report.object_id]) {
			reportFilesByObject[report.object_id] = []
		}

		const files = report.files.map((file) => ({
			...file,
			...{
				reportId: report.id,
				workTitle: report.work.title,
			},
		}))

		reportFilesByObject[report.object_id] = [...reportFilesByObject[report.object_id], ...files]
	}
})

const prescriptionFiles = props.prescriptions.flatMap((prescription) =>
	Array.isArray(prescription?.files) ? prescription.files : []
)
</script>

<template>
	<div>
		<h1 style="text-align: center">
			{{ project.title }}
			{{ project.contract }}
		</h1>

		<p style="text-align: center" v-if="project.img?.url">
			<img :src="project.img.url" />
		</p>

		<h1 style="text-align: center">ЕЖЕМЕСЯЧНЫЙ ОТЧЕТ №{{ project.id }}</h1>

		<h2 style="text-align: center">
			За период: c {{ dateDate(doc.date_start) }} по {{ dateDate(doc.date_end) }}
		</h2>

		<p>
			<strong>Заказчик:</strong>
			{{ project?.customer?.name }}
		</p>

		<p>
			<strong>Консультант:</strong>
			{{ project.branch.title }}
		</p>

		<table>
			<tbody>
				<tr>
					<td>
						<p>
							<strong>Сдал:</strong>
						</p>

						<p>
							{{ project.branch.title }}
						</p>

						<p>
							{{ project.branch.coordinator_post }}
						</p>

						<p>{{ project.branch.coordinator_name }} _________________________</p>
					</td>

					<td>
						<p>
							<strong>Принял:</strong>
						</p>

						<p>
							{{ project?.customer?.name }}
						</p>

						<p>
							{{ project?.customer?.contact_person_post }}
						</p>

						<p>{{ project?.customer?.contact_person }} _________________________</p>
					</td>
				</tr>

				<tr>
					<td>
						М.П.
						<p></p>
						<p></p>
						<p></p>
						<p></p>
						<p></p>
						<p></p>
					</td>

					<td>
						М.П.
						<p></p>
						<p></p>
						<p></p>
						<p></p>
						<p></p>
						<p></p>
					</td>
				</tr>
			</tbody>
		</table>

		<h3>1. ОБЩАЯ ИНФОРМАЦИЯ</h3>

		<p>
			{{ project.description }}
		</p>

		<p>
			<strong>Таблица 1. Список объектов</strong>
		</p>

		<table>
			<tr>
				<th>МЕСТОПОЛОЖЕНИЕ</th>
				<th>ОБЪЕКТЫ</th>
			</tr>

			<tr v-for="object in objects" :key="object.id">
				<td>
					{{ object.address }}
				</td>
				<td>
					{{ object.title }}
				</td>
			</tr>
		</table>

		<h3>2. МЕТОДОЛОГИЯ И ПЛАН ВЫПОЛНЕНИЯ ТЕХНИЧЕСКОГО НАДЗОРА</h3>

		<h4>2.1 МЕТОДОЛОГИЯ</h4>

		<p>
			{{ project.methodology }}
		</p>

		<h4>2.2 ПЛАН ВЫПОЛНЕНИЯ ТЕХНИЧЕСКОГО НАДЗОРА</h4>

		<p>
			{{ project.technical_plan }}
		</p>

		<h4>2.3 РАСПРЕДЕЛЕНИЕ КОМАНДЫ</h4>

		<p>
			{{ project.team_distribution }}
		</p>

		<p>
			<strong>Таблица 2. Ключевые специалисты для выполнения Задачи</strong>
		</p>

		<table>
			<tr>
				<th>№</th>
				<th>ФИО Инженера по техническому надзору</th>
				<th>Возложенная задача</th>
			</tr>

			<tr v-for="(spec, index) in mainSpecialists" :key="spec.id">
				<td>
					{{ index + 1 }}
				</td>
				<td>
					{{ spec.name }}
				</td>
				<td>
					{{ spec.object.title }}
				</td>
			</tr>
		</table>

		<p></p>

		<p>
			<strong> Таблица 3. Не ключевые специалисты </strong>
		</p>

		<table>
			<tr>
				<th>№</th>
				<th>ФИО специалиста</th>
				<th>Должность</th>
			</tr>
			<tr v-for="(specialist, index) in minorSpecialists" :key="specialist.id">
				<td>
					{{ index + 1 }}
				</td>
				<td>
					{{ specialist.name }}
				</td>
				<td>
					{{ specialist.post }}
				</td>
			</tr>
		</table>

		<p></p>

		<p>
			<strong>Таблица 4. Финансовые показатели</strong>
		</p>

		<table>
			<tr>
				<th>Дата</th>
				<th>Вид работ</th>
				<th>Расчетная стоимость</th>
				<th>Фактическая</th>
			</tr>
			<tr v-for="item in workTypeStatistics" :key="item.id">
				<template v-if="item?.work?.title">
					<td>
						{{ dateDate(item.created_at) }}
					</td>
					<td>
						{{ item?.work?.title }}
					</td>
					<td>
						{{ item.cost }}
					</td>
					<td>
						{{ item.avr_cost }}
					</td>
				</template>
			</tr>
		</table>

		<p></p>

		<p>
			<strong> Таблица 5. Человеческие ресурсы</strong>
		</p>

		<table>
			<tr>
				<th>Дата</th>
				<th>Вид работ</th>
				<th>Расчетное кол-во рабочих</th>
				<th>Фактическое кол-во рабочих</th>
			</tr>
			<tr v-for="item in workTypeStatistics" :key="item.id">
				<template v-if="item?.work?.title">
					<td>
						{{ dateDate(item.created_at) }}
					</td>
					<td>
						{{ item.work.title }}
					</td>
					<td>
						{{ item.planned_workers }}
					</td>
					<td>
						{{ item.workers }}
					</td>
				</template>
			</tr>
		</table>

		<p></p>

		<h3>3. ЭКОЛОГИЧЕСКИЕ И СОЦИАЛЬНЫЕ СТАНДАРТЫ</h3>

		<p>
			{{ project.social_standarts }}
		</p>

		<h3>4. ТЕХНИКА БЕЗОПАСНОСТИ И ОХРАНА ТРУДА</h3>

		<p>
			{{ project.safety }}
		</p>

		<h3>5. ОБЪЕМ ВЫПОЛНЕННЫХ СМР ЗА ОТЧЕТНЫЙ МЕСЯЦ</h3>

		<p>
			<strong>Отчетный период:</strong> {{ dateDate(doc.date_start) }} -
			{{ dateDate(doc.date_end) }}
		</p>

		<template v-for="(object, index) in objects" :key="object.id">
			<template v-if="object.reports && object.reports.length > 0">
				<p>
					<strong>{{ index + 1 }}. Объект №{{ object.id }}</strong>
					{{ object.title }}
				</p>

				<p><strong>Проектная компания:</strong> {{ object.project_company }}</p>

				<p><strong>Подрядчик:</strong> {{ object.organization }}</p>

				<p><strong>ИТН:</strong> {{ object.implementer.name }}</p>

				<table>
					<tr>
						<th>№</th>
						<th>Вид работ</th>
						<th>Процент выполнения</th>
						<th>Инспекция №</th>
						<th>Дата</th>
					</tr>
					<tr v-for="(report, index) in object.reports" :key="report.id">
						<td>
							{{ index + 1 }}
						</td>
						<td>
							{{ report.work.title }}
						</td>
						<td>
							{{ report.completed }}
						</td>
						<td>
							{{ report.id }}
						</td>
						<td>
							{{ dateDate(report.created_at) }}
						</td>
					</tr>
				</table>
				<p></p>

				<table v-if="reportFilesByObject[object.id]">
					<tr
						v-for="(files, index) in groupItems(reportFilesByObject[object.id], 4)"
						:key="index">
						<td v-for="file in files" colwidth="250">
							<img :src="file.url" />
							<p>{{ file.workTitle }} ({{ file.reportId }})</p>
							<p>{{ file.title }}</p>
						</td>
					</tr>
				</table>
				<p></p>
			</template>
		</template>

		<template v-for="object in objects" :key="object.id">
			<template v-if="object.prescriptions && object.prescriptions.length > 0">
				<p>
					<strong>Предписания к объекту №{{ object.id }}</strong>
				</p>

				<p>
					<strong>Отчетный период:</strong> {{ dateDate(doc.date_start) }} -
					{{ dateDate(doc.date_end) }}
				</p>

				<table>
					<tr>
						<th>№</th>
						<th>Вид работ</th>
						<th>Дата</th>
						<th>Инспекция №</th>
						<th>Срок исполнения</th>
					</tr>
					<tr
						v-for="(prescription, index) in object.prescriptions"
						:key="prescription.id">
						<td>
							{{ index + 1 }}
						</td>
						<td>
							{{ prescription.work.title }}
						</td>
						<td>
							{{ dateDate(prescription.created_at) }}
						</td>
						<td>
							{{ prescription.id }}
						</td>
						<td>
							{{ dateDate(prescription.resolve_before) }}
						</td>
					</tr>
				</table>
				<p></p>

				<table>
					<tr v-for="(files, index) in groupItems(prescriptionFiles, 4)" :key="index">
						<template v-for="file in files" :key="file.id">
							<td colwidth="250">
								<img :src="file.path" />
								<p>{{ file.title }}</p>
							</td>
						</template>
					</tr>
				</table>
				<p></p>
			</template>

			<template v-if="object.checklists && object.checklists.length > 0">
				<h4>Чек-листы</h4>

				<table>
					<tr>
						<th colwidth="30">№</th>
						<th>Заголовок</th>
						<th>Дата</th>
						<th>Заполнил</th>
						<th>Вопрос-ответ</th>
					</tr>
					<tr v-for="(checklist, index) in object.checklists" :key="checklist.id">
						<td>
							{{ index + 1 }}
						</td>
						<td>
							{{ checklist.title }}
						</td>
						<td>
							{{ dateDate(checklist.created_at) }}
						</td>
						<td>
							{{ checklist.employee.name }}
						</td>
						<td>
							<table>
								<tr v-for="(question, index) in checklist.questions" :key="index">
									<td>{{ question.text }}</td>
									<td>{{ t('checklist.value_' + question.value) }}</td>
								</tr>
							</table>
						</td>
					</tr>
				</table>
				<p></p>
			</template>
		</template>

		<h3>6. ПЛАН РАБОТ НА СЛЕДУЮЩИЙ МЕСЯЦ</h3>

		<p>[описание] Поле для заполнения ПМ</p>
	</div>
</template>

<style>
.tiptap .img {
	max-width: 100% !important;
}
</style>
